import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { useHeight } from "../hooks/index.js";
import { useAdditionalFetchDataHelpersPluginCallback } from "../../AdditionalFetchDataHelpersPlugin/index.js";
import { MediaEmpty } from "../../../../../MediaEmpty/index.js";
import { Box } from "../../../../../Box/index.js";
import { Typography } from "../../../../../Typography/index.js";
import { Skeleton } from "../../../../../Skeleton/index.js";
import { WysiwygContext } from "../../../context/index.js";
import { useLogger } from "../../../../../services/hooks/index.js";
import { ImagesGallerySlider } from "./ImagesGallerySlider.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ImagesGallery_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ImagesGallery_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const ImagesGallery = (t0)=>{
    const $ = c(25);
    const { images, description, editable } = t0;
    const { maxHeight, editorHeight } = useHeight();
    const contextHelpers = useAdditionalFetchDataHelpersPluginCallback();
    const { apiUrl } = useContext(WysiwygContext);
    const logger = useLogger();
    const height = editable ? editorHeight : maxHeight;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [formatedImages, setFormatedImages] = useState(t1);
    const [failedImageCounter, setFailedImageCounter] = useState(0);
    const hasError = failedImageCounter === images.length;
    let t2;
    if ($[1] !== contextHelpers || $[2] !== formatedImages.length || $[3] !== images || $[4] !== logger) {
        t2 = ()=>{
            if (formatedImages.length) return;
            if (null == contextHelpers ? void 0 : contextHelpers.getAttachmentUrl) {
                let failedImages = 0;
                const imagesList = images.map((image)=>_async_to_generator(function*() {
                        const imageSrc = yield contextHelpers.getAttachmentUrl(image.id).then(_temp).catch((err)=>{
                            logger.error(err, {
                                tags: {
                                    vkdoc_error_type: "wysiwyg input image gallery"
                                }
                            });
                            failedImages += 1;
                            return "";
                        });
                        return _object_spread_props(_object_spread({}, image), {
                            src: imageSrc
                        });
                    })());
                Promise.all(imagesList).then((result)=>{
                    setFormatedImages(()=>result);
                    setFailedImageCounter(()=>failedImages);
                });
            }
        };
        $[1] = contextHelpers;
        $[2] = formatedImages.length;
        $[3] = images;
        $[4] = logger;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== apiUrl || $[7] !== contextHelpers || $[8] !== formatedImages || $[9] !== images || $[10] !== logger) {
        t3 = [
            formatedImages,
            images,
            contextHelpers,
            apiUrl,
            logger
        ];
        $[6] = apiUrl;
        $[7] = contextHelpers;
        $[8] = formatedImages;
        $[9] = images;
        $[10] = logger;
        $[11] = t3;
    } else t3 = $[11];
    useEffect(t2, t3);
    if (!formatedImages.length) {
        let t4;
        if ($[12] !== height) {
            t4 = /*#__PURE__*/ jsx(Skeleton, {
                height: height,
                width: "100%",
                variant: "rect"
            });
            $[12] = height;
            $[13] = t4;
        } else t4 = $[13];
        return t4;
    }
    if (failedImageCounter === images.length) {
        let t4;
        if ($[14] !== height) {
            t4 = /*#__PURE__*/ jsx(MediaEmpty, {
                height: height,
                variant: "multiple",
                radius: "m"
            });
            $[14] = height;
            $[15] = t4;
        } else t4 = $[15];
        return t4;
    }
    let t4;
    if ($[16] !== editable || $[17] !== formatedImages || $[18] !== hasError) {
        t4 = /*#__PURE__*/ jsx(ImagesGallerySlider, {
            images: formatedImages,
            hasError: hasError,
            editable: editable
        });
        $[16] = editable;
        $[17] = formatedImages;
        $[18] = hasError;
        $[19] = t4;
    } else t4 = $[19];
    let t5;
    if ($[20] !== description) {
        t5 = description && /*#__PURE__*/ jsx(Typography, {
            variant: "caption",
            color: "text.light.tertirary",
            children: description
        });
        $[20] = description;
        $[21] = t5;
    } else t5 = $[21];
    let t6;
    if ($[22] !== t4 || $[23] !== t5) {
        t6 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            flexDirection: "column",
            gap: "12",
            children: [
                t4,
                t5
            ]
        });
        $[22] = t4;
        $[23] = t5;
        $[24] = t6;
    } else t6 = $[24];
    return t6;
};
function _temp(res) {
    return res;
}
export { ImagesGallery };
